import React from 'react';
import FormField from './FormField';

export default function EnrollmentForm({ t, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="rounded-2xl border bg-slate-800/50 p-6 shadow-xl">
      <div className="grid gap-4 sm:grid-cols-2">
        <FormField label={t.contact.form.first} id="firstName" required />
        <FormField label={t.contact.form.last} id="lastName" required />
      </div>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        <FormField label={t.contact.form.phone} id="phone" type="tel" required />
        <FormField label={t.contact.form.email} id="email" type="email" required />
      </div>
      <div className="mt-4">
        <label htmlFor="program" className="mb-1 block text-sm font-medium text-slate-200">
          {t.contact.form.program}
        </label>
        <select 
          id="program" 
          name="program" 
          required 
          className="w-full rounded-xl border bg-slate-900/60 px-3 py-2 text-slate-100"
        >
          <option value="">Select program</option>
          {t.contact.form.programOptions.map((p) => (
            <option key={p} value={p}>{p}</option>
          ))}
        </select>
      </div>
      <div className="mt-4">
        <label htmlFor="message" className="mb-1 block text-sm font-medium text-slate-200">
          {t.contact.form.message}
        </label>
        <textarea 
          id="message" 
          name="message" 
          rows={4} 
          className="w-full rounded-xl border bg-slate-900/60 px-3 py-2 text-slate-100" 
          placeholder={t.contact.form.messagePH} 
        />
      </div>
      <button 
        type="submit" 
        className="mt-6 w-full rounded-2xl bg-red-600 px-5 py-3 text-base font-semibold text-white hover:bg-red-700"
      >
        {t.contact.form.submit}
      </button>
    </form>
  );
}
